require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-zezi-6-r.json") })
        }
      }, "path---photos-professional-zezi-6-r");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-zezi-6-r!./.cache/json/photos-professional-zezi-6-r.json
// module id = 1205
// module chunks = 231608221292675